import React from 'react';
import { styled } from 'mz-ui-kit';
import TrainField from 'mz-ui-kit/form/TrainField';
import Alert from 'mz-ui-kit/core/Alert';

const ErrorContainer = styled('div', {
  marginTop: '10px',
});

export default function TrainFieldWithError(props) {
  return (
    <>
      <TrainField {...props} />
      {props.meta?.error && props.meta?.touched && (
        <ErrorContainer>
          <Alert color="red">{props.meta?.error}</Alert>
        </ErrorContainer>
      )}
    </>
  );
}
